import React from "react";

// Donut Chart Component avec progression visuelle
export const DonutChart = ({ principal, secondaire, plafondPrincipal, plafondSecondaire, hasDoubleActivite }) => {
  const percentPrincipal = Math.min(100, (principal / plafondPrincipal) * 100);
  const percentSecondaire = hasDoubleActivite ? Math.min(100, (secondaire / plafondSecondaire) * 100) : 0;
  
  // Couleurs en fonction du % atteint
  const getColorByPercent = (percent, isSecondaire = false) => {
    if (percent >= 90) return '#ef4444'; // Rouge si critique
    if (percent >= 80) return '#f59e0b'; // Orange si attention
    return isSecondaire ? '#7C6BB5' : '#F8BC91'; // Violet (secondaire) ou Orange corail (principale)
  };

  const colorPrincipal = getColorByPercent(percentPrincipal, false);
  const colorSecondaire = getColorByPercent(percentSecondaire, true);
  
  // Calculs pour le cercle SVG
  const size = hasDoubleActivite ? 220 : 180;
  const strokeWidth = 16;
  const gap = 10; // Espace entre les deux cercles
  
  // Cercle extérieur (principal)
  const radiusPrincipal = (size - strokeWidth) / 2;
  const circumferencePrincipal = 2 * Math.PI * radiusPrincipal;
  const progressPrincipal = circumferencePrincipal - (percentPrincipal / 100) * circumferencePrincipal;
  
  // Cercle intérieur (secondaire) 
  const strokeWidthSecondaire = 14;
  const radiusSecondaire = radiusPrincipal - strokeWidth - gap;
  const circumferenceSecondaire = 2 * Math.PI * radiusSecondaire;
  const progressSecondaire = circumferenceSecondaire - (percentSecondaire / 100) * circumferenceSecondaire;

  return (
    <div className="relative mx-auto flex flex-col items-center">
      <div className="relative" style={{ width: size, height: size }}>
        {/* SVG Principal */}
        <svg width={size} height={size} className="transform -rotate-90 absolute inset-0" style={{ overflow: 'visible' }}>
          {/* Fond cercle principal - Orange clair */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radiusPrincipal}
            fill="none"
            stroke="#FDEBD0"
            strokeWidth={strokeWidth}
          />
          {/* Progression cercle principal */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radiusPrincipal}
            fill="none"
            stroke={colorPrincipal}
            strokeWidth={strokeWidth}
            strokeDasharray={circumferencePrincipal}
            strokeDashoffset={progressPrincipal}
            strokeLinecap="round"
            style={{ transition: 'stroke-dashoffset 0.5s ease, stroke 0.3s ease' }}
          />
        </svg>
        
        {/* SVG Secondaire - SÉPARÉ */}
        {hasDoubleActivite && (
          <svg width={size} height={size} className="transform -rotate-90 absolute inset-0" style={{ overflow: 'visible' }}>
            {/* Fond cercle secondaire */}
            <circle
              cx={size / 2}
              cy={size / 2}
              r={radiusSecondaire}
              fill="none"
              stroke="#DDD6FE"
              strokeWidth={strokeWidthSecondaire}
            />
            {/* Progression cercle secondaire */}
            <circle
              cx={size / 2}
              cy={size / 2}
              r={radiusSecondaire}
              fill="none"
              stroke={colorSecondaire}
              strokeWidth={strokeWidthSecondaire}
              strokeDasharray={circumferenceSecondaire}
              strokeDashoffset={progressSecondaire}
              strokeLinecap="round"
              style={{ transition: 'stroke-dashoffset 0.5s ease, stroke 0.3s ease' }}
            />
          </svg>
        )}
        
        {/* Texte central */}
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-2xl font-bold" style={{color: colorPrincipal}}>{percentPrincipal.toFixed(0)}%</span>
          {hasDoubleActivite && (
            <span className="text-lg font-bold" style={{color: colorSecondaire}}>{percentSecondaire.toFixed(0)}%</span>
          )}
        </div>
      </div>
      
      {/* Légende sous le cercle */}
      <div className="flex items-center gap-4 mt-3 text-xs">
        <div className="flex items-center gap-1">
          <div className="w-3 h-3 rounded-full" style={{backgroundColor: colorPrincipal}}></div>
          <span>Principale</span>
        </div>
        {hasDoubleActivite && (
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 rounded-full" style={{backgroundColor: colorSecondaire}}></div>
            <span>Secondaire</span>
          </div>
        )}
      </div>
    </div>
  );
};
